import React, { useState } from "react";
import "../../../../../../../css/weigh-in.sass"
import "../../../../../../../css/highlow.sass"
import styled from "styled-components";
import { Accordion } from "../components/setting-accordion";
import { SaveButton } from "../components/save-button";
import Dialog from "@material-ui/core/Dialog";
import HighLowTable from './highlow-table.js'
import SettingIcon from "../../../../../../../images/settings-icons/setting-tour.png";
import Icon from "@material-ui/core/Icon";
import Snackbar from "@material-ui/core/Snackbar";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;


const UpdateHighLow = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [showSnack, setShowSnack] = useState(false);
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [showHighLowModal, setShowHighLowModal] = useState(false);


  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}
        icon={SettingIcon}
        settingName="High / Low days"
        currentSetting={props.account.user.high_low_enabled ? 'On' : 'Off'}
        // description="What is your target weight?"
        roundTop
      >
        <ButtonRow>
          <SaveButton
            text="Update High / Low days"
            // disabled={disabled}
            isLoading={isLoading}
            onClick={() => setShowHighLowModal(true)}
          />
        </ButtonRow>
      </Accordion>
      <Dialog
        className="inspect-modal-setting"
        fullScreen
        open={showHighLowModal}
        onClose={() => setShowHighLowModal(false)}
        autoScrollBodyContent={true}
      >
        <div className="check-in-close">
          <button onClick={() => setShowHighLowModal(false)}>
            <Icon>close</Icon>
          </button>
        </div>
        <div className="inspect-modal-setting">
          <div className="check-in-content">
            <HighLowTable 
              setShowHighLowModal={setShowHighLowModal}
              loadPortalAccount={props.loadPortalAccount}
              openSnackbar={props.openSnackbar}
              portalId={props.portalId}
              userId={props.account.user.id}
              protein={props.account.user.protein}
              carbs={props.account.user.carbs}
              tdee={props.account.user.tdee}
              fat={props.account.user.fat}
              calories={props.account.user.calories}
              highLowFactor={props.account.user.high_low_factor}
              highLowMask={props.account.user.high_low_mask}
              highLowTweaks={props.account.user.high_low_tweaks}
              lastWeighInDate={props.account.user.lastWeighInDate}
              macroHistory={props.account.user.macroHistory}
              settingsMacros={props.account.user.settingsMacros}
              macroAdjustments={props.account.user.macroAdjustments}
              // isLoading: state.user.isLoading
            />
          </div>
        </div>
      </Dialog>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={showSnack}
        onClose={() => setShowSnack(false)}
        autoHideDuration={3000}
      >
        <div className="setting-snack">
          {message}
          <button onClick={() => setShowSnack(false)}>
            <Icon>close</Icon>
          </button>
        </div>
      </Snackbar>
    </>
  );
};

// function mapStateToProps(state) {
//   return {
//     isLoading: state.user.isLoading,
//     userId: state.user.id,
//     targetWeight: state.user.target_weight,
//     isUsingMetric: state.user.use_metric_units,
//     goal: state.user.goal,
//     weight: state.user.weight,
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ modifyUser, loadProfile }, dispatch);
// }

// export default connect(mapStateToProps, mapDispatchToProps)(UpdateTargetWeight);
export default UpdateHighLow;
